<div
  *ngIf="value"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="10px"
>
  <mat-form-field>
    <mat-select
      placeholder="Period"
      [value]="value!.period"
      (selectionChange)="valueChanged($event.value)"
    >
      <mat-option i18n [value]="periodSelection.OneHour">One Hour</mat-option>
      <mat-option i18n [value]="periodSelection.SixHours">Six Hours</mat-option>
      <mat-option i18n [value]="periodSelection.TwelveHours"
        >Twelve Hours</mat-option
      >
      <mat-option i18n [value]="periodSelection.OneDay">One Day</mat-option>
      <mat-option i18n [value]="periodSelection.SevenDays"
        >Seven Days</mat-option
      >
      <mat-option i18n [value]="periodSelection.ThirtyDays"
        >Thirty Days</mat-option
      >
      <mat-option i18n [value]="periodSelection.OneYear">One Year</mat-option>
      <mat-option i18n [value]="periodSelection.ThreeYears"
        >Three Years</mat-option
      >
      <mat-option i18n [value]="periodSelection.FiveYears"
        >Five Years</mat-option
      >
      <mat-option i18n [value]="periodSelection.Custom">Custom</mat-option>
    </mat-select>
  </mat-form-field>
  <ng-container *ngIf="value?.period === periodSelection.Custom">
    <mat-form-field>
      <input
        matInput
        [value]="value.fromDate"
        (dateChange)="dateChange($event, true)"
        [matDatepicker]="from"
        i18n-placeholder
        placeholder="From (date)"
      />
      <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
      <mat-label i18n>From (date)</mat-label>
      <mat-datepicker [touchUi]="isHandset" #from></mat-datepicker>
    </mat-form-field>
    <pcp-mat-timepicker
      placeholder="From (time)"
      i18n-placeholder
      color="primary"
      [userTime]="value.fromTime"
      (userTimeChange)="userTimeChanged($event, true)"
    ></pcp-mat-timepicker>
    <mat-form-field>
      <input
        matInput
        [value]="value.toDate"
        (dateChange)="dateChange($event, false)"
        [matDatepicker]="to"
        i18n-placeholder
        placeholder="To (date)"
      />
      <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
      <mat-label i18n>To (date)</mat-label>
      <mat-datepicker [touchUi]="isHandset" #to></mat-datepicker>
    </mat-form-field>
    <pcp-mat-timepicker
      placeholder="To (time)"
      i18n-placeholder
      color="primary"
      [userTime]="value.toTime"
      (userTimeChange)="userTimeChanged($event, false)"
    ></pcp-mat-timepicker>
  </ng-container>
</div>
